import React, { useCallback, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { useRouteMatch, Link } from 'react-router-dom'
import { ButtonMenu, ButtonMenuItem, Flex, Text, Toggle } from '@pancakeswap-libs/uikit'
import useI18n from 'hooks/useI18n'
import { BigNumber } from 'bignumber.js'

const PanelBox = styled.div`
    background-color:${({ theme }) => theme.isDark?theme.alert.background:'rgb(238, 234, 244)'} ;
    border:${({ theme }) => theme.isDark?'1px solid rgb(85 66 66)':'rgb(215, 202, 236);'} ;
    /* background-color: rgb(238, 234, 244);
    border: 1px solid rgb(215, 202, 236); */
    border-radius: 16px;
    box-shadow: rgb(74 74 104 / 10%) 0px 2px 2px -1px inset;
    padding: 8px 16px;
    max-width:310px;
`
const LeftBottom = styled.div`
    color: ${({ theme }) => theme.colors.textSubtle};
    font-weight: 400;
    line-height: 1.5;
    font-size: 12px;
    text-align: right;
`
const InputPirce = styled.input`
    /* color: rgb(40, 13, 95); */
    color: ${({ theme }) => theme.colors.textSubtle};
    display: block;
    font-size: 16px;
    height: 40px;
    outline: 0px;
    padding: 0px 16px;
    width: 100%; 
    background: transparent;
    border-radius: 0px;
    box-shadow: none;
    padding-left: 0px;
    padding-right: 0px;
    text-align: right;
    border: none;
    :focus-visible{
      outline: none;
    }
`
const Unit = styled.div`
    margin-left: 4px;
    text-align: right;
    /* color: rgb(122, 110, 170); */
    color: ${({ theme }) => theme.colors.textSubtle};
    white-space: nowrap;
`

const Icon = styled.svg`
  fill: ${({ theme }) => theme.colors.textSubtle};
  margin-left: 10px;
  cursor: pointer;
`


export interface BalanceTranProps {
  priceUsd:string,
  lpLabel:string,
  changeUsd:(e)=> void,
  setShowIsOpen:(e)=> void,
  lpPrice:number
}
const BalanceTran: React.FC<BalanceTranProps> = ({lpPrice,priceUsd,lpLabel,changeUsd,setShowIsOpen}) => {
  const TranslateString = useI18n()
  const countRef = useRef(false);
  /**
    * LP数量
  */
  const [lpNumber, setLpNumber] = useState('100');
  /**
    * usd单位和价格
  */
  const [priceUSdValue, setPriceUSdValue] = useState(priceUsd);
  const [unitVal,setUnitVal]=useState("USD")
  /**
    * 默认 100 EBEN-BCH LP
    * 转换后的值 eg: 100 EBEN-BCH LP || 100 USD
  */
  const [tranVal,setTranVal]=useState(lpNumber)
  const [tranUnit,setTranUnit]=useState(lpLabel)

  const update = useRef("USD");
  const calculateUsd=(inputVal:string):string=>{
    // TO DO: 计算USD
    const principalAsUsdBN = new BigNumber(inputVal).times(lpPrice)
    const principalAsUsdString = principalAsUsdBN.gt(0) ? principalAsUsdBN.toFixed(2) : '0.00'
    return principalAsUsdString;
   }
   const calculateLp=useCallback((inputVal:string):string=>{
      // TO DO: 计算LP
      const principalAsTokenBN = new BigNumber(inputVal).div(lpPrice)
      const principalAsToken = principalAsTokenBN.gt(0) ? principalAsTokenBN.toFixed(10) : '0.00'
      return principalAsToken;
   },[lpPrice])
   
  const handleSetValue = (e) => {
    let val=null;
    if(e.target.value===''){
       val=0;
       setPriceUSdValue('');
    }else{
       val=e.target.value
       setPriceUSdValue(val);
    }
  
 
    // 根据单位计算LP，或者USD
    // setTranVal(parseFloat(e.target.value)+10)
    if(update.current==='USD'){
      setTranVal(calculateLp(val))
    }else{
      setTranVal(calculateUsd(val))
    }
  };

  const clickChange=()=>{
    const tran=[{v:priceUSdValue,u:unitVal},{v:tranVal,u:tranUnit}];
    let [a,b]= tran;
    [b,a]=[a,b];

    setPriceUSdValue(a.v)
    setUnitVal(a.u)
    update.current=a.u;

    setTranVal(b.v)
    setTranUnit(b.u)
  }

  /**
    * 外部priceUsd 传入发生改变重新计算 转换值
  */
  const changePriceUsd=useCallback(()=>{
    if(countRef.current===false){
        if(update.current==='USD'){
          setTranVal(calculateLp(priceUsd))
          setPriceUSdValue(priceUsd)
        }else{
          setTranVal(priceUsd)
          setPriceUSdValue(calculateLp(priceUsd))
        }
    }
  },[priceUsd,calculateLp])

  useEffect(()=>{
    changePriceUsd();
  },[priceUsd,changePriceUsd])
  /**
    * 抛出 改变后的 priceUsd 
  */
  useEffect(()=>{
    if(unitVal==='USD'){
      changeUsd(priceUSdValue);
    }else{
      changeUsd(tranVal);
    }
  },[priceUSdValue,tranVal,changeUsd,unitVal])

  return (
    <PanelBox>
      <Flex justifyContent='flex-end'>
        <div>
          <Flex alignItems='center'>
               <Flex flex={1}> 
                <InputPirce
                placeholder="0.00"       
                pattern='^[0-9]*[.,]?[0-9]{0,18}$'
                inputMode="decimal"
                value={priceUSdValue} 
                onBlur={()=>{countRef.current=false}}
                onFocus={()=>{countRef.current=true;setShowIsOpen(false)}}
                onChange={handleSetValue}/>
               </Flex>
               <Unit>{unitVal}</Unit>
              
          </Flex>
          <LeftBottom>{tranVal} {tranUnit}</LeftBottom>
        </div>

        <Flex alignItems='center' onClick={clickChange}><Icon xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 512 512" width="16px"><path d="m366.996094 512c-11.046875 0-20-8.953125-20-20v-316.007812h-85.992188c-15.777344 0-29.894531-9.433594-35.96875-24.035157-6.097656-14.660156-2.8125-31.398437 8.367188-42.648437l91.09375-91.632813c11.332031-11.398437 26.425781-17.675781 42.5-17.675781 16.074218 0 31.167968 6.277344 42.5 17.675781l91.09375 91.632813c11.183594 11.246094 14.46875 27.988281 8.371094 42.648437-6.074219 14.601563-20.195313 24.035157-35.972657 24.035157h-21.988281c-11.046875 0-20-8.953126-20-20 0-11.046876 8.953125-20 20-20h19.710938l-89.582032-90.113282c-3.769531-3.789062-8.785156-5.878906-14.132812-5.878906-5.34375 0-10.363282 2.089844-14.132813 5.878906l-89.582031 90.113282h83.714844c22.058594 0 40 17.945312 40 40v316.007812c0 11.042969-8.953125 20-20 20zm0 0"/><path d="m144.988281 512c-16.074219 0-31.167969-6.277344-42.5-17.675781l-91.09375-91.632813c-11.183593-11.25-14.46875-27.988281-8.367187-42.648437 6.070312-14.601563 20.191406-24.039063 35.96875-24.039063h85.992187v-316.003906c0-11.046875 8.953125-20 20-20s20 8.953125 20 20v316.007812c0 22.054688-17.945312 40-40 40h-83.714843l89.582031 90.113282c3.769531 3.789062 8.789062 5.878906 14.132812 5.878906s10.363281-2.089844 14.132813-5.878906l89.582031-90.113282h-19.710937c-11.046876 0-20-8.953124-20-20 0-11.046874 8.953124-20 20-20h21.988281c15.777343 0 29.894531 9.433594 35.96875 24.035157 6.097656 14.660156 2.816406 31.402343-8.367188 42.648437l-91.09375 91.632813c-11.332031 11.398437-26.425781 17.675781-42.5 17.675781zm0 0"/></Icon></Flex>
      </Flex>
    </PanelBox>
  )
}

export default BalanceTran

